import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';
import { CreateTableViewParams, isServiceRequestViewType, ServiceRequestViewFilters } from './types';

function normalizeServiceRequestFilters(filters: ServiceRequestViewFilters): ServiceRequestViewFilters {
  const { service, ...rest } = filters;
  const serviceArray = service
    ? Array.isArray(service) ? service : [service]
    : undefined;
  return {
    ...rest,
    ...(serviceArray ? { service: serviceArray } : {}),
  };
}

export async function createTableView(
  params: CreateTableViewParams,
): Promise<{ success: boolean; id?: string; error?: string }> {
  try {
    const apiFilters = params.filters
      ? isServiceRequestViewType(params.type)
        ? normalizeServiceRequestFilters(params.filters as ServiceRequestViewFilters)
        : params.filters
      : undefined;

    const res = await fetcher(
      API_BASE_PATH,
      {
        method: 'POST',
        body: {
          ...params,
          filters: apiFilters,
        },
      },
      undefined
    );

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      return {
        success: false,
        error: errorData.message || 'Failed to create table view',
      };
    }

    const data = await res.json();
    return {
      success: true,
      id: data.tableView?.id,
    };
  } catch (error) {
    return {
      success: false,
      error: 'Failed to create table view',
    };
  }
}
